let config = {
    settingLogoUploadFileSize: 2 * 1024 * 1024,
    settingLogoUploadSizeLimit: { width: 300, height: 300 },
    settingChangeMobileCaptchaCooldown: 60,
    // cookie过期时间10年
    userTokenExpire: 1000 * 3600 * 24 * 30 * 12 * 10,
    companyHost: process.env.COMPANY_HOST,
    apiHost: process.env.API_HOST,
    goApiHost: process.env.GO_API_HOST,
    interviewHost: process.env.INTERVIEW_HOST,
    aiInterviewHost: process.env.AI_INTERVIEW_HOST,
    examHost: process.env.EXAM_HOST,
    viBakHost: process.env.VIBAK_HOST,
    examCHost: process.env.EXAM_C_HOST,
    saasHost: process.env.SAAS_HOST,
    homeHost: process.env.HOME_HOST,
    trailHost: process.env.TRAIL_HOST,
    trailSecret: process.env.TRAIL_SECRET,
    routerMode: process.env.ROUTER_MODE,
    testAppID: 'cff39ef8094e4a50b2802cb0d0bda489',
    trailAppCode: 'hina_vi',
    helpUrl: 'http://hinapower.udesk.cn/hc/sections/90581?api_name=',
    noticeUrl: 'http://hinapower.udesk.cn/hc/articles/163891',
    umeng: process.env.UMENG || '',
    uploadClient: process.env.UPLOAD_CLIENT,
    uploadSecret: process.env.UPLOAD_SECRET,
    uploadAppCode: process.env.UPLOAD_APPCODE,
    websocketUrl: process.env.WEBSOCKET_URL,
};
export default config;



// WEBPACK FOOTER //
// ./src/util/config.js